// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryCoverListing_root__uy6Uj","shimmerBox":"CategoryCoverListing_shimmerBox__js812"};